import React from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { CanonicalToolRenderer } from '../../../components/Space/SpaceChat/renderers/canonical/CanonicalToolRendererRegistry';

export const ContactsDiscoverRenderer: CanonicalToolRenderer = {
  icon: MagnifyingGlass,
  displayName: 'Discover Contacts',
  getVerb: (isExecuting) => (isExecuting ? 'Discovering' : 'Discovered'),

  getHeaderMessage: (context) => {
    const data = context.execution.result?.view?.data;
    if (!data) return null;
    const n = data.discovered ?? 0;
    return n > 0 ? `${n} new contact${n !== 1 ? 's' : ''} found` : 'No new contacts';
  },

  shouldResolveEntity: false,
  useEntityIcon: false,
  isNavigable: false,
  defaultExpanded: true,
  supportsStreaming: true,

  renderExecuting: ({ execution }) => {
    const progress = execution.result?.view?.progress || execution.progress || 'Scanning Gmail threads...';
    const discovered = execution.result?.view?.data?.discovered ?? 0;

    return (
      <div className="contacts-discover-renderer contacts-discover-renderer--executing">
        <p className="contacts-discover-renderer__progress">{progress}</p>
        {discovered > 0 && (
          <p className="contacts-discover-renderer__count">
            {discovered} new contact{discovered !== 1 ? 's' : ''} found so far
          </p>
        )}
      </div>
    );
  },

  renderCompleted: ({ execution }) => {
    const data = execution.result?.view?.data || {};
    const discovered = data.discovered ?? 0;

    if (discovered === 0) {
      return (
        <div className="contacts-discover-renderer contacts-discover-renderer--empty">
          Your contacts are up to date — no new contacts found.
        </div>
      );
    }

    return (
      <div className="contacts-discover-renderer contacts-discover-renderer--completed">
        <p className="contacts-discover-renderer__summary">
          {discovered} new contact{discovered !== 1 ? 's' : ''} added from your Gmail threads.
          Open the Contacts app to review and enrich them.
        </p>
      </div>
    );
  },

  renderError: ({ execution }) => (
    <div className="contacts-discover-renderer contacts-discover-renderer--error">
      Discovery failed: {execution.error}
    </div>
  ),
};
